module.exports = __webpack_public_path__ + "static/img/34-1.4bf880d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/34-1.jpg
// module id = pXG2
// module chunks = 0